import { useEffect, useState } from "react";
import { BASE_URL } from "src/ApiCall/BaseUrl";

const useSse = (url?: string) => {
  const [data, setData] = useState<any>([]);
  const [error, setError] = useState<any>();

  useEffect(() => {
    if (!url) return;
    const sse = new EventSource(
      `${BASE_URL}${url}`
      //   "http://localhost:5000/api/v1/notification/sse/5"
      // { withCredentials: true }
    );

    sse.onmessage = (e) => setData(JSON.parse(e.data));
    sse.onerror = (e) => {
      // error log here

      setError(e);
      sse.close();
    };
    return () => {
      sse.close();
    };
  }, [url]);

  return {
    data,
    error,
  };
};

export default useSse;
